<template>
  <div class="req-title">
    <p class="title-text text-h2">
      {{ title }}
    </p>
    <OnHoldBadge v-if="onHold" />
  </div>
</template>

<script setup>
import OnHoldBadge from '@/components/requisitions/OnHoldBadge.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  onHold: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less" scoped>
.req-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  p.title-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: @text-darkest;
    font-weight: 500;
  }

  :deep(span) {
    min-width: 72px;
    margin-left: 8px;
  }
}
</style>
